import { Command } from '../command/command';
import { Phone } from '../../core/model/phone';
import { PhoneBrand } from '../../core/model/phone-brand';
import { PhoneModel } from '../../core/model/phone-model';
import { Customer } from '../../core/model/customer';
import { StepGuard } from '../../core/model/step-guard';
import { Estimate } from '../../core/model/estimate';
import { Payment } from '../../core/model/payment';

export class AddCurrentWizzardStep implements Command {
  readonly name = 'add_current_wizzard_step';

  constructor(private _step: StepGuard) {
  }

  get step(): StepGuard {
    return this._step;
  }
}
export class AddCustomerPhoneCommand implements Command {
  readonly name = 'add_customer_phone';

  constructor(private _phone: Phone) {
  }

  get phone(): Phone {
    return this._phone;
  }
}

export class AddBrandToCustomerPhoneCommand implements Command {
  readonly name = 'add_brand_to_customer_phone';

  constructor(private _brand: PhoneBrand) {
  }

  get brand(): PhoneBrand {
    return this._brand;
  }
}

export class AddModelToCustomerPhoneCommand implements Command {
  readonly name = 'add_model_to_customer_phone';

  constructor(private _model: PhoneModel) {
  }

  get model(): PhoneModel {
    return this._model;
  }
}

export class AddCustomerTypeCommand implements Command {
  readonly name = 'add_customer_type';

  constructor(private _type: string) {
  }

  get type(): string {
    return this._type;
  }
}

export class AddCustomerDetailsCommand implements Command {
  readonly name = 'add_customer_details';

  constructor(private _customer: Customer) {
  }

  get customer(): Customer {
    return this._customer;
  }
}

export class AddEstimationIdCommand implements Command {
  readonly name = 'add_estimation_id';

  constructor(private _id: string) {
  }

  get id(): string {
    return this._id;
  }
}

export class AddEstimateCommand implements Command {
  readonly name = 'add_estimate';

  constructor(private _estimate: Estimate) {
  }

  get estimate(): Estimate {
    return this._estimate;
  }
}

export class AddCustomerIdCommand implements Command {
  readonly name = 'add_customer_id';

  constructor(private _id: string) {
  }

  get id(): string {
    return this._id;
  }
}

export class AddOrderIdCommand implements Command {
  readonly name = 'add_order_id';

  constructor(private _id: string) {
  }

  get id(): string {
    return this._id;
  }
}

export class AddPaymentIdCommand implements Command {
  readonly name = 'add_payment_id';

  constructor(private _id: string) {
  }

  get id(): string {
    return this._id;
  }
}


export class AddPaymentCommand implements Command {
  readonly name = 'add_payment';

  constructor(private _payment: Payment) {
  }

  get payment(): Payment {
    return this._payment;
  }
}


export class AddInvoicePdfIdCommand implements Command {
  readonly name = 'add_invoice_pdf_id';

  constructor(private _id: string) {
  }

  get id(): string {
    return this._id;
  }
}



// WEBPACK FOOTER //
// ./src/app/state/order/order-commands.ts